import { DocumentNode, MutationOptions } from 'apollo-boost';
import { GraphQLClient } from 'types';

export const createMutation =
  <V, T>(doc: DocumentNode) =>
  (client: GraphQLClient, options: Omit<MutationOptions<T, V>, 'mutation'>) =>
    client.mutate<T, V>({
      mutation: doc,
      ...options,
    });
